export default function viewStory({record,editParams}) {
    if (record.storyId) {
        return {
            name: "查看稿件", condition:null,conditionFun:()=>true,onOk: () => {
                let activitiConfName = "activitiTreeRoot-appointment";
                window.openEditById({
                    params: {
                        businessId: record.id,
                        activitiConfName,
                        ...editParams,
                    },
                    configName: "reservationEditor",
                    id: record.storyId
                });
            }
        };
    }
}